var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _ellipse, _text, _text2, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 320,
    viewBox: "0 0 420 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 160,
    r: 150,
    fill: "#F5E6F5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 70,
    r: 22,
    fill: "#FBF0DE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 230,
    r: 16,
    fill: "#E7EEF9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 60,
    r: 10,
    fill: "#E7F5EC"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 250,
    r: 12,
    fill: "#E7EEF9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 160,
    r: 118,
    stroke: "#DFB0DF",
    strokeWidth: 2,
    strokeDasharray: "6 10",
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210,
    cy: 276,
    rx: 110,
    ry: 14,
    fill: "#F0D9F0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 195,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontSize: 104,
    fill: "#91278F"
  }, "404")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 195,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 800,
    fontSize: 104,
    fill: "none",
    stroke: "#7A2074",
    strokeWidth: 1,
    opacity: 0.25
  }, "404")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(246 118) rotate(18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FEFAFE",
    stroke: "#91278F",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 45,
    x2: 66,
    y2: 66,
    stroke: "#91278F",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26 L36 26 M26 16 L26 36",
    stroke: "#D14C2E",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56 196)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 60,
    rx: 6,
    fill: "#FEFAFE",
    stroke: "#91278F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 38,
    y2: 16,
    stroke: "#DFB0DF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 28,
    x2: 38,
    y2: 28,
    stroke: "#DFB0DF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 40,
    x2: 26,
    y2: 40,
    stroke: "#DFB0DF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316 150) rotate(-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 38,
    height: 48,
    rx: 5,
    fill: "#FEFAFE",
    stroke: "#2456A6",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 30,
    y2: 13,
    stroke: "#E7EEF9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 30,
    y2: 23,
    stroke: "#E7EEF9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 33,
    x2: 20,
    y2: 33,
    stroke: "#E7EEF9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIllustration);
export default __webpack_public_path__ + "static/media/not_found_illustration.d42b9845bdf18cd0d188f0db5eee02f6.svg";
export { ForwardRef as ReactComponent };